"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnFilter = void 0;
const react_1 = __importStar(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const ramda_1 = require("ramda");
const column_filter_styles_1 = require("./column-filter.styles");
const generic_1 = require("../../../../generic");
const localization_1 = require("../../../../localization");
const ColumnFilter = ({ anchorEl, isLoading, filterOptions, selected, onClose, onApply, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [searchText, setSearchText] = (0, react_1.useState)('');
    const sortedFilterOptions = (0, react_1.useMemo)(() => filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.sort((a, b) => (a.label.toLowerCase() > b.label.toLowerCase() ? 1 : -1)), [filterOptions]);
    const selectedValue = (0, react_1.useMemo)(() => selected !== null && selected !== void 0 ? selected : sortedFilterOptions === null || sortedFilterOptions === void 0 ? void 0 : sortedFilterOptions.map(({ id }) => id), [sortedFilterOptions, selected]);
    const [selectedIds, setSelectedIds] = (0, react_1.useState)(selectedValue);
    (0, react_1.useEffect)(() => {
        if (anchorEl) {
            setSelectedIds(selectedValue);
        }
    }, [anchorEl, selectedValue]);
    const isSelected = (0, react_1.useCallback)((id) => selectedIds.includes(id), [selectedIds]);
    const handleSelect = (0, react_1.useCallback)((id) => {
        const updatedSelectedIds = new Set(selectedIds);
        if (updatedSelectedIds.has(id)) {
            updatedSelectedIds.delete(id);
        }
        else {
            updatedSelectedIds.add(id);
        }
        setSelectedIds(Array.from(updatedSelectedIds));
    }, [selectedIds]);
    const handleApply = () => {
        onApply((filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions.length) === selectedIds.length ? undefined : selectedIds);
        onClose();
    };
    const filteredOptions = (0, react_1.useMemo)(() => sortedFilterOptions === null || sortedFilterOptions === void 0 ? void 0 : sortedFilterOptions.filter(({ label }) => label.toLowerCase().includes(searchText.toLowerCase())), [searchText, sortedFilterOptions]);
    const options = (0, react_1.useMemo)(() => {
        if (isLoading) {
            return [];
        }
        return filteredOptions.map(({ id, label }) => (react_1.default.createElement(material_1.FormControlLabel, { key: id, control: react_1.default.createElement(ui_components_1.Checkbox, { checked: isSelected(id), onChange: () => handleSelect(id) }), label: label })));
    }, [filteredOptions, handleSelect, isLoading, isSelected]);
    const isAllSelected = (0, react_1.useMemo)(() => new Set([...selectedIds, ...filteredOptions.map(({ id }) => id)]).size === selectedIds.length, [filteredOptions, selectedIds]);
    const handleSelectAll = () => {
        const uniqueIds = new Set(selectedIds);
        const actionName = isAllSelected ? 'delete' : 'add';
        filteredOptions.forEach(({ id }) => {
            uniqueIds[actionName](id);
        });
        setSelectedIds(Array.from(uniqueIds));
    };
    const areActionsDisabled = isLoading || (0, ramda_1.isEmpty)(filteredOptions !== null && filteredOptions !== void 0 ? filteredOptions : []);
    return (react_1.default.createElement(material_1.Popover, { open: !!anchorEl, onClose: onClose, anchorEl: anchorEl, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'left',
        } }, react_1.default.createElement(column_filter_styles_1.StyledContainer, null, react_1.default.createElement(column_filter_styles_1.StyledSearchInput, { onChange: (e) => setSearchText(e.target.value), value: searchText, placeholder: t({ key: 'SEARCH' }), startAdornment: react_1.default.createElement(material_1.InputAdornment, { position: "start" }, react_1.default.createElement(ui_components_1.Icon, { variant: "search", color: ui_components_1.baseColors.primaryGreen400, className: "search-icon" })) }), react_1.default.createElement("div", { className: 'content' }, isLoading && react_1.default.createElement(generic_1.SimpleLoading, null), options), react_1.default.createElement(material_1.Divider, null), react_1.default.createElement("div", { className: "footer" }, react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", title: isAllSelected ? t({ key: 'CLEAR_ALL' }) : t({ key: 'SELECT_ALL' }), disabled: areActionsDisabled, onClick: handleSelectAll }), react_1.default.createElement(ui_components_1.Button, { rounded: true, color: "primary", title: t({ key: 'APPLY' }), variant: "contained", disabled: areActionsDisabled, onClick: handleApply })))));
};
exports.ColumnFilter = ColumnFilter;
exports.default = exports.ColumnFilter;
